import { render } from "./testChat.vue?vue&type=template&id=4db407b6"
import script from "./testChat.vue?vue&type=script&lang=js"
export * from "./testChat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__